

















































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { DeliveryCompany, Warehouse, AddTemplate, GetDeliveryTemplate } from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import { ncpPopup } from '@/utils/ncp';
import deliveryTypes from '@/const/words/deliveryTypes';
import deliveryConditionTypes from '@/const/words/deliveryConditionTypes';
import WeightFee from './WeightFee.vue';
import NumberInput from '@/components/common/NumberInput.vue';

@Component({ components: { CompSelectBox, WeightFee, NumberInput } })
export default class DeliveryGroupTemplateModifyForm extends Vue {
  @Prop() private template!: AddTemplate | GetDeliveryTemplate;
  private deliveryTypes = deliveryTypes;
  private deliveryConditionTypes = deliveryConditionTypes;
  @Prop({ default: [] }) private deliveryCompanyTypes!: DeliveryCompany[];
  @Prop({ default: [] }) private warehouses!: Warehouse[];
  @Prop({ default: 'KRW' }) private currencyCode!: string;
  @Prop({ default: false }) private hasDefaultTemplate!: boolean;
  private AMT_MAX_LENGTH = 9;
  private tempDefaultState: boolean = false;

  private inputErrorFlag = {
    returnDeliveryAmt: false,
  };
  get displayDeliveryCompanyTypes() {
    return [
      { deliveryCompanyType: null, label: this.$t('DELIVERY_GROUP_TEMPLATE_DELIVERY_COMPANY') },
      ...this.deliveryCompanyTypes,
    ];
  }
  private modify() {
    if (this.validation()) {
      if (this.template.deliveryFee.deliveryConditionType === 'QUANTITY_PROPOSITIONAL_FEE') {
        this.template.deliveryFee.criteria = 0;
      } else {
        this.template.deliveryFee.perOrderCnt = 0;
      }
      
      // 기본 템플릿이 변경된 경우에만 부모에게 알림
      if (this.tempDefaultState !== this.template.default) {
        this.template.default = this.tempDefaultState;
        this.$emit('defaultTemplateChanged', this.template);
      }
      
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_GUIDE'));
      this.$emit('modifyTemplate', this.template);
      this.$emit('close');
    }
  }

  private validateOnBlur(value?: string): boolean {
    if (this.currencyCode === 'KRW' && Number(value ?? 0) % 10) {
      alert('10원 단위로 입력해주세요.');

      return false;
    }
    return true;
  }

  private created() {
    // 기본 템플릿이 없는 경우에만 현재 템플릿을 기본으로 설정
    this.tempDefaultState = this.template.default || !this.hasDefaultTemplate;
  }

  private closeModifyForm() {
    this.$emit('close');
  }

  private validation() {
    if (!this.template.name) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE1'));
      return false;
    }
    if (!this.template.deliveryFee.deliveryConditionType) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE2'));
      return false;
    }
    if (
      this.template.deliveryFee.deliveryConditionType === 'QUANTITY_PROPOSITIONAL_FEE' &&
      !(Number(this.template.deliveryFee.perOrderCnt) > 0)
    ) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE15'));
      return false;
    }
    if (
      !['FREE', 'WEIGHT_FEE'].includes(this.template.deliveryFee.deliveryConditionType) &&
      !this.template.deliveryFee.deliveryAmt
    ) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE3'));
      return false;
    }

    if (this.template.deliveryFee.deliveryConditionType === 'WEIGHT_FEE') {
      if (!this.template.deliveryFee.deliveryFeeRanges) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE3'));
        return false;
      }
      const isWeightValidate = this.template.deliveryFee.deliveryFeeRanges.every((deliveryFeeRange: any, idx) => {
        if (idx === this.template.deliveryFee.deliveryFeeRanges.length - 1) {
          return deliveryFeeRange.aboveOrEqual;
        }
        return deliveryFeeRange.aboveOrEqual && deliveryFeeRange.below;
      });

      const isAmountValidate = this.template.deliveryFee.deliveryFeeRanges.every(deliveryFeeRange => {
        if (typeof deliveryFeeRange.deliveryAmt === 'number') {
          return deliveryFeeRange.deliveryAmt >= 0;
        }
        return deliveryFeeRange.deliveryAmt;
      });

      if (!isWeightValidate) {
        alert('중량을 설정해주세요.');
        return false;
      }

      if (!isAmountValidate) {
        alert('배송비를 설정해주세요.');
        return false;
      }
    }

    if (!this.template.deliveryFee.returnDeliveryAmt) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE6'));
      return false;
    }
    return true;
  }
  private openPopup() {
    const title = this.$t('RETURN_WAREHOUSE_ADD');
    ncpPopup('/warehouse/addForm', title, 1024, 500);
  }
  checkNumber(e: Event, type: string) {
    let value: any = (e.target as HTMLInputElement).value;
    if (!value.match(/[^\d]/g)) {
      return;
    } else {
      value = Number(value.replace(/[^\d]/g, ''));
    }
    switch (type) {
      case 'returnDeliveryAmt':
        this.inputErrorFlag.returnDeliveryAmt = true;
        this.template.deliveryFee.returnDeliveryAmt = value;
        break;
      case 'criteria':
        this.template.deliveryFee.criteria = value;
        break;
      case 'perOrderCnt':
        this.template.deliveryFee.perOrderCnt = value;
        break;
      case 'deliveryAmt':
        this.template.deliveryFee.deliveryAmt = value;
        break;
      default:
        break;
    }
  }
}
